import _isEmpty from 'lodash/isEmpty';
import _isObject from 'lodash/isObject';
export function getAuthorAttributes(author) {
  if (_isObject(author) && !_isEmpty(author)) {
    var _author$firstName = author.firstName,
      firstName = _author$firstName === void 0 ? '' : _author$firstName,
      _author$lastName = author.lastName,
      lastName = _author$lastName === void 0 ? '' : _author$lastName,
      _author$email = author.email,
      email = _author$email === void 0 ? '' : _author$email;
    return {
      firstName: firstName,
      lastName: lastName,
      email: email
    };
  }
  return {};
}
export function formatAuthorName() {
  var firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(firstName, " ").concat(lastName).trim();
}
export function formatAuthor(author) {
  if (_isEmpty(author)) {
    return '';
  }
  var _getAuthorAttributes = getAuthorAttributes(author),
    firstName = _getAuthorAttributes.firstName,
    lastName = _getAuthorAttributes.lastName,
    email = _getAuthorAttributes.email;
  if (firstName && lastName) {
    return formatAuthorName(firstName, lastName);
  }
  if (email) {
    return email;
  }
  return '';
}